import Image from "next/image";
import React, { FC } from "react";
import { arbitrum, base, bsc, mainnet, optimism } from "viem/chains";

const CHAIN_LOGOS: Record<number, string> = {
  [base.id]: "https://icons.llamao.fi/icons/chains/rsz_base.jpg",
  [mainnet.id]: "https://icons.llamao.fi/icons/chains/rsz_ethereum.jpg",
  [arbitrum.id]: "https://icons.llamao.fi/icons/chains/rsz_arbitrum.jpg",
  [optimism.id]: "https://icons.llamao.fi/icons/chains/rsz_optimism.jpg",
  [bsc.id]: "https://icons.llamao.fi/icons/chains/rsz_bsc.jpg",
};

interface ChainLogoProps {
  chain: number;
  className?: string;
  size?: number;
}

export const ChainLogo: FC<ChainLogoProps> = ({
  chain,
  className,
  size = 24,
}) => {
  const src = CHAIN_LOGOS[chain];

  if (!src) return null;

  return (
    <Image
      src={src}
      width={size}
      height={size}
      className={className}
      alt={`Chain ${chain}`}
    />
  );
};
